"use client";

import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ClipboardList, FilePlus2, FileCheck2, User as UserIcon } from "lucide-react";
import logo from "../assets/DesarrollandoTerritorios.png";
import BackToMenu from "../components/BackToMenu.jsx";

export default function OtrasNecesidadesCDPRP() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [roleName, setRoleName] = useState("");

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("auth_user");
      if (!storedUser) { navigate("/login", { replace: true }); return; }
      const user = JSON.parse(storedUser);
      setUserEmail(user.email || "");
      const roleId = Number(user.role_id ?? user.rolId ?? user.roleId ?? 0);
      const roleKey = String(user.role ?? user.roleName ?? user.rol ?? "").toLowerCase();
      const LABELS = {
        1: "Solicitante", 2: "Planeación", 3: "Hacienda", 4: "Jurídica",
        5: "Alcalde", 6: "Administrador", 7: "Presupuesto", 8: "Almacén", 14: "SST",
      };
      const NAME_LABELS = { solicitante: "Solicitante", presupuesto: "Presupuesto" };
      setRoleName(NAME_LABELS[roleKey] || LABELS[roleId] || "");
    } catch (e) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  const cardBase = {
    display: "block",
    textDecoration: "none",
    color: "inherit",
    borderRadius: 16,
    background: "white",
    border: "1px solid #e5e7eb",
    padding: 28,
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
    transition: "transform 120ms ease, box-shadow 120ms ease",
    cursor: "pointer",
  };

  const cardHover = {
    transform: "translateY(-3px)",
    boxShadow: "0 14px 28px rgba(0,0,0,0.10)",
  };

  const withHover = (base) => ({
    style: { ...base },
    onMouseEnter: (e) => Object.assign(e.currentTarget.style, cardHover),
    onMouseLeave: (e) => Object.assign(e.currentTarget.style, base),
  });

  const cards = [
    {
      to: "/otras-necesidades-cdp-rp/solicitados",
      icon: <ClipboardList size={26} color="#1e40af" />,
      iconBg: "#eff6ff",
      title: "Solicitados",
      desc: "Ver el estado de los CDPs y RPs que has enviado a Presupuesto.",
      accent: "#1e40af",
    },
    {
      to: "/otras-necesidades-cdp-rp/nuevo-cdp",
      icon: <FilePlus2 size={26} color="#854d0e" />,
      iconBg: "#fef9c3",
      title: "Radicar CDP",
      desc: "Diligenciar y enviar un nuevo formulario de CDP a Presupuesto.",
      accent: "#854d0e",
    },
    {
      to: "/otras-necesidades-cdp-rp/nuevo-rp",
      icon: <FileCheck2 size={26} color="#166534" />,
      iconBg: "#dcfce7",
      title: "Radicar RP",
      desc: "Diligenciar y enviar un nuevo formulario de RP a Presupuesto.",
      accent: "#166534",
    },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: "#f7f8fa",
        padding: "24px",
      }}
    >
      {/* Back */}
      <div style={{ width: "100%", maxWidth: 1100, marginBottom: 8 }}>
        <BackToMenu label="Volver al menú" />
      </div>

      {/* Hero */}
      <section
        style={{
          width: "100%",
          maxWidth: 1100,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16,
          marginBottom: 32,
        }}
      >
        <img src={logo} alt="Logo" style={{ height: 160, width: "auto" }} />
        <h1 style={{ fontSize: 28, fontWeight: 800, color: "#1e3a8a", textAlign: "center", margin: 0 }}>
          Otros CDPs y RPs
        </h1>
        <p style={{ fontSize: 15, color: "#6b7280", textAlign: "center", margin: 0 }}>
          Solicita CDPs y RPs fuera del flujo normal de contratos
        </p>

        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            background: "#eef2ff",
            color: "#1e3a8a",
            borderRadius: 999,
            padding: "10px 14px",
            fontSize: 14,
            boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
            marginTop: 4,
          }}
        >
          <UserIcon size={16} />
          {userEmail || "usuario@correo.com"}
          {roleName ? ` (${roleName})` : ""}
        </div>
      </section>

      {/* Cards */}
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div
          style={{
            width: "100%",
            maxWidth: 1100,
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: 20,
          }}
        >
          {cards.map((card) => (
            <Link
              key={card.to}
              to={card.to}
              {...withHover({
                ...cardBase,
                borderTop: `4px solid ${card.accent}`,
              })}
              aria-label={card.title}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                <div
                  style={{
                    display: "grid",
                    placeItems: "center",
                    width: 56,
                    height: 56,
                    borderRadius: 14,
                    background: card.iconBg,
                    flexShrink: 0,
                  }}
                >
                  {card.icon}
                </div>
                <div>
                  <h2 style={{ fontSize: 20, fontWeight: 700, color: card.accent, margin: 0 }}>
                    {card.title}
                  </h2>
                  <p style={{ fontSize: 14, color: "#6b7280", margin: "5px 0 0" }}>
                    {card.desc}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}